import { apiClient } from '@/lib/apiClient';
import type { Empresa, AtualizarEmpresaRequest } from '../types';

export const empresaService = {
  async listar(): Promise<Empresa[]> {
    const { data } = await apiClient.get<Empresa[]>('/api/config/empresas');
    return data;
  },

  async getById(id: number): Promise<Empresa> {
    const { data } = await apiClient.get<Empresa>(`/api/config/empresas/${id}`);
    return data;
  },

  /** Devolve o aviso da API quando o cadastro foi salvo mas algo ficou para conferir. */
  async atualizar(id: number, req: AtualizarEmpresaRequest): Promise<string | undefined> {
    const { data } = await apiClient.put<{ aviso?: string } | ''>(`/api/config/empresas/${id}`, req);
    return data ? data.aviso : undefined;
  },
};

// ── ViaCEP (busca endereço por CEP) ──────────────────────────────────────
export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  erro?: boolean;
}

export async function buscarCep(cep: string): Promise<ViaCepResponse | null> {
  const clean = cep.replace(/\D/g, '');
  if (clean.length !== 8) return null;
  try {
    const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
    const data: ViaCepResponse = await res.json();
    return data.erro ? null : data;
  } catch {
    return null;
  }
}
